import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';
import {getTPAID} from  '../global_helpers/sessionReturn.js';

const state = {
    tpaContext: {
        tpa: null
    },
    siteAdmin: {
        TpaList: [],
    },
};

const getters = {
    getTpaContext: (state) => state.tpaContext,
    getSiteAdminTpaList: (state) => state.siteAdmin.TpaList,
};

const actions = {

    async getTpa({commit, dispatch}){
        let authHeader = getAuthHeader();
        let tpa_id = getTPAID();
        axios.get("/tpa/?tpa_id="+tpa_id, authHeader)        
        .then((res) => {
            sessionStorage.setItem('tpaName', res.data.tpa.tpa_name);
            commit('setTPA', res.data.tpa);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'There was an error loading your company!', {root: true});
        });
    },

    async adminCreateTpa({dispatch}, tpaObj){
        let authHeader = getAuthHeader();
        axios.post("/tpa/", {tpa:tpaObj}, authHeader)
        .then(() => {
            dispatch('raiseMessage', `Successfully created ${tpaObj.tpa_name}.`, {root: true});
            dispatch('adminGetTpaList');
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `There was an error creating ${tpaObj.tpa_name}!`, {root: true});
        });
    },
    
    async updateTpa({commit, dispatch}, tpaObj = false){
        let authHeader = getAuthHeader();
        axios.put("/tpa/", tpaObj, authHeader)
        .then((res) => {
            commit('setTPA', res.data.tpa);
            dispatch('raiseMessage', 'Successfully updated your company information!', {root: true});
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', 'There was an error updating your company information!', {root: true});
        });
    },
    
    async adminUpdateTpa({commit, dispatch}, tpaObj = false){
        let authHeader = getAuthHeader();
        axios.put("/tpa/", {tpa:tpaObj}, authHeader)
        .then((res) => {
            commit('setTPA', res.data.tpa);
            dispatch('raiseMessage', `Successfully updated ${tpaObj.tpa_name}!`, {root: true});
            dispatch('adminGetTpaList');
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `There was an error updating ${tpaObj.tpa_name}!`, {root: true});
        });
    },

    async adminGetTpaList({commit, dispatch}){
        let authHeader = getAuthHeader();
        axios.get("/tpa/list/", authHeader)        
        .then((res) => {
            commit('adminSetTpaList', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'There was an error loading the TPA list!', {root: true});
        });
    }
};

const mutations = {
    setTPA(state, tpa){
        state.tpaContext.tpa = tpa;
    },

    adminSetTpaList(state, list){
        list.sort((a,b) => a.tpa_name.toLowerCase() > b.tpa_name.toLowerCase());
        state.siteAdmin.TpaList = list;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};